import script from "./edit.vue?vue&type=script&setup=true&lang=js"
export * from "./edit.vue?vue&type=script&setup=true&lang=js"

import "./edit.vue?vue&type=style&index=0&id=6da3bcc7&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_influencer_admin_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6da3bcc7"]])

export default __exports__